import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import ElementUI from 'element-ui'

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'

import '@/icons' // icon
import '@/permission' // permission control
import globalFunction from '@/utils/globalFunction'
import FixedTwoButton from '@/components/FixedTwoButton/FixedTwoButton'
import ServingCell from '@/components/ServingCell/index.vue'
import DivisionTitle from '@/components/DivisionTitle/DivisionTitle'
import ElButton from '@/components/ElButton/ElButton'
import parenSelect from '@/components/parenSelect/index.vue'
import ElImg from '@/components/ElImg'
import LookQrCode from '@/components/LookQrCode'
import LeadingOut from '@/components/LeadingOut'
import UploadFile from '@/components/UploadFile/UploadFile'
import ELPopover from '@/components/ELPopover'
import permission from '@/directive/permission'
import ELEmpty from '@/components/ELEmpty'
import Grid from '@/components/Grid'
import GridItem from './components/Grid/components/GridItem.vue'
import ETips from '@/components/ETips/index.vue'
import { enumList } from '@/utils/globalEnumeration'
import { getCurrentOrganizationId, getFirstCommunityId, getRoutesCut } from '@/utils/auth'

Vue.use(permission)
Vue.use(ElementUI)
Vue.use(globalFunction)

Vue.component('Grid', Grid)
Vue.component('ETips', ETips)
Vue.component('GridItem', GridItem)
Vue.component('ServingCell', ServingCell)
Vue.component('ELEmpty', ELEmpty)
Vue.component('FixedTwoButton', FixedTwoButton)
Vue.component('DivisionTitle', DivisionTitle)
Vue.component('ELButton', ElButton)
Vue.component('parenSelect', parenSelect)
Vue.component('LookQrCode', LookQrCode)
Vue.component('LeadingOut', LeadingOut)
Vue.component('UploadFile', UploadFile)
Vue.component('ElImg', ElImg)
Vue.component('ELPopover', ELPopover)

Vue.config.productionTip = false

Vue.mixin({
  computed: {
    picker_Options() {
      return {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
      }
    },
    enumList() {
      return enumList
    },
    imgStaticUrl() {
      return 'https://static.jiuyun.vip/uniapp'
    },
    // 用户信息
    USER_INFO() {
      return store.getters.userInfo
    },
    USER_ID() {
      return store.getters.userId
    },
    USER_NAME() {
      return store.getters.name
    },
    USER_STAFF_ID() {
      return store.getters.staffId
    },
    subsidiaryDropLists() {
      // 公司下拉列表
      const list = store.getters.subsidiaryLists || []
      return list.map(e => {
        return {
          ...e,
          organizationName: e.organizationName || e.companyName,
        }
      })
    },

    companyCreditLimit() {
      // 公司额度
      return store.getters.organizationInfo.createNum
    },
    buildingRoomLimit() {
      //房屋额度
      return store.getters.organizationInfo.buildingRoomNumber
    },
    ORGANIZATION_TYPE() {
      // 0街道 1物业公司 2政府监管部门 3平台
      // 机构类型
      return store.getters.organizationInfo.organizationType
    },

    PERSONNELORGANIZATION_ID() {
      //1是总部人员  2是项目人员
      return store.getters.personnelOrganization
    },

    ORGANIZATION_ID() {
      // 机构id
      return store.getters.organizationInfo.organizationId
    },

    ORGANIZATION_NAME() {
      // 机构name
      return store.getters.organizationInfo.organizationName
    },
    TENANTID() {
      // 租户id
      return store.getters.tenantId
    },
    ORGANIZATION_LEVEL() {
      // 机构等级
      return store.getters.organizationInfo.organizationLevel
    },
    searchCommunities() {
      // 项目权限-列表查询
      return store.getters.companyPermissionCommunityLists
    },
    organizationLevel() {
      // 机构等级-新增、编辑用
      let level = store.getters.organizationInfo.organizationLevel
      return level === 0 ? 1 : level === 1 ? 2 : ''
    },
    sidebarIsOpen() {
      // 判断侧边栏是否展开
      return store.state.app.sidebar.opened
    },
    firstCommunityId() {
      return store.getters.firstCommunityId || getFirstCommunityId('firstCommunityId')
    },
    currentOrganizationId() {
      // 当前选择的机构
      return store.getters.currentOrganizationId || getCurrentOrganizationId('currentOrganizationId')
    },
    routesCut() {
      return store.getters.routesCut || getRoutesCut('routesCut')
    },
  },
})

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
})
